// extracted by mini-css-extract-plugin
module.exports = {"inputGroup":"inputGroup-3TNdcn0","input":"input-g7bAUuW","consents":"consents-4y1SfFF","marketing":"marketing-H8kiIMD","terms":"terms-3ZvZCIY"};